/*global SunergoPlatform*/

const initSaveDialog = function(form) {
	let fieldTriggers = form.element.dataset.saveDialog;
	if (!fieldTriggers) return false;

	if (fieldTriggers != 'always') fieldTriggers = JSON.parse(fieldTriggers);
	else fieldTriggers = false;

	const saveDialogId = `formSave_${form.name}` || '';
	const saveDialog = SunergoPlatform.dialogs.get(saveDialogId);
	if (!saveDialogId || !saveDialog) return;

	form.saveDialogConfirmed = false;

	const showSaveDialog = function() {
		if (!form.saveDialogConfirmed && fieldTriggers != false) {
			if (form.changeLog && form.changeLog.items && form.changeLog.items.length > 0) {
				let found = false;
				for (let i = 0; i < fieldTriggers.length; i++) {
					if (form.changeLog.findItem(fieldTriggers[i])) {
						found = true;
						break;
					}
				}
				form.saveDialogConfirmed = !found;
			} else form.saveDialogConfirmed = true;
		}

		if (!form.saveDialogConfirmed) {
			const confirmButton = saveDialog.$el.querySelector('[data-action="formSubmit"]');
			confirmButton.addEventListener('click', function() {
				form.saveDialogConfirmed = true;
				saveDialog.hide();
				form.submit();
			});
			saveDialog.show();
		}
		return form.saveDialogConfirmed;
	};
	form.preSubmit.push(showSaveDialog);
};

export default initSaveDialog;